import script from "./queryCertificate.vue?vue&type=script&setup=true&lang=js"
export * from "./queryCertificate.vue?vue&type=script&setup=true&lang=js"

import "./queryCertificate.vue?vue&type=style&index=0&id=3cd1bf5d&lang=less&scoped=true"

import exportComponent from "D:\\openAi\\chinese-academy-of-sciences-home\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3cd1bf5d"]])

export default __exports__